import { NavController, NavParams, ModalController } from 'ionic-angular';
import {Component, ViewChild} from '@angular/core';
import {ToastController,AlertController} from 'ionic-angular';
import { Headers , RequestOptions } from '@angular/http';
import {SearchCustomersPage} from "../search-customers/search-customers";
import {CartPage} from '../cart/cart';
import {CartManager} from "../../providers/cart-manager";
import {ItemsPage} from '../items/items';
import {Api} from '../../providers/api';
import {IMAGES_BASE_URL,Constants,ApplicationVariables } from '../../providers/config';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage';
import {Printer, PrintOptions, Push} from 'ionic-native';
import { MsgManager } from '../../providers/msg-manager';
import { ThankYouModalPage } from '../thank-you-modal/thank-you-modal';
import { GVLogger } from '../../services/gv-logger';
import { PickPackParamsPage } from '../pickpackparams/pickpackparams';
import { CART } from '../../providers/data';
import { shipmentCART } from '../../providers/data';
import { customFieldsProvider } from '../../providers/params';
import { LicenseStatusModelPage } from '../license-status-model/license-status-model';
import { ProductLocationsModelPage } from '../product-locations-model/product-locations-model';
import {ConfirmShipmentPage} from "../confirm-shipment/confirm-shipment";
import {ShipmentcartManagerProvider} from "../../providers/shipmentcart-manager";
import {ItemPage} from "../item-details/item-details";
import {ShipmentReadyPage} from "../shipment-ready/shipment-ready";
import {LoginPage} from "../login/login";


@Component({
  selector: 'page-pickpacklist',
  templateUrl: 'pickpacklist.html',
})
export class PickpacklistPage {

  baseImageUrl = IMAGES_BASE_URL.imageBaseUrl;

  isOfflineMode:any;

  salesPerson;

  currentDate;
  placeOrderButton = true;

  attributesPropertiesMap:any = new Map();
  shipto = '';
  constants = Constants;

  space: string = ", ";
  spaceAddress1 : string;
  spaceAddress2 : string;
  public shipToVal : any = "shipto";
  BOLVariables = [];
  lengthTotalizer = 0;

  adpCustomerInfo :any ={};

  public cart: any;
  public TotalPrice: number = 0;
  public TotalPriceBeforeTax: number = 0;
  public taxPercent = 0; // Changed from 0.13
  public taxAmount = 0;
  public locationSelected: any;
  public locationSelectedObject: any;
  public expectedShipmentDate: any = "";
  public orderMessage = "";
  spaceCity: string;
  spaceState: string;
  spaceCountry: string;
  deoded: string;
  TAX: number = 0;
  order: any;
  selectFirstBillTo: any;
  pickPackParamsVariables: any;
  SoldToCompany;
  SoldToAddress;
  lengthTotalizerr: string;
  lengthTotalizerDecimalFix: string;
  shipOrderButton = true;
  downloadCSVButtonStatus = true;
  private shipmentCart: any;
  private qty = 0;
  private shipmentsData= [];
  private shipmentsAvailabilityCheck: boolean = false;
  private shipmentsLength = 0;
  @ViewChild('barcodeFocusOnProductScan') barcodeFocusOnProductScan;
  private regularProductsAvailCheck: boolean = false;
  private allProdAvailCheck = false;
  arr = ["W1Z2A1S3B1", "mango", "banana", "sugar"];
  private totalQtyOfSelectedProducts = 0;
  private totalQtyOrdered = 0;
  private quantityRemainingInPickPack = 0;
  private pageStatus = "";
  private orderStatus: any = 0;
  productLocationDisplayStatus: boolean = true;
  pickLocationButtonStatus = false;

  constructor(public nav: NavController,
   private cartManager:CartManager,
   private api:Api,public storage: Storage,
    public toastCtrl: ToastController,
    public params:NavParams,
     public alertCtrl: AlertController,
     public msgManager:MsgManager,
     private gVLogger:GVLogger,
     private modalCtrl:ModalController,
     public paramsProvider : customFieldsProvider,
     private shipmentCartManager:ShipmentcartManagerProvider) {


      this.shipmentCart = shipmentCART;
      this.attributesPropertiesMap = this.cartManager.getAllAttributesPropertiesMap();
      this.adpCustomerInfo = this.cartManager.getAdpCustomerInfo();

    this.salesPerson = this.cartManager.getSalesPerson();
    this.isOfflineMode  = ApplicationVariables.isOffline;

      this.cart = this.params.get("cart");
      this.order = this.params.get("orderView");
      this.orderStatus = this.cart.orderStatus;
      this.gVLogger.log("OrderStatus : " + this.orderStatus);
    this.shipments();

    for(let item of this.cart.items){

      if(item.productType === 0){
        this.regularProductsAvailCheck = true;
        break;
      }
    }

    if(!this.regularProductsAvailCheck && this.orderStatus != 5){
      this.pageStatus = "shipmentforOok";

      setTimeout(() =>{
        this.reviewShipment();
      },1000)

    }

    this.productsIncart();

      for ( let item of this.cart.items){
        try{
          let length = item.name.split('|')[4].split(':')[0];
        length = Number(length.trim());
        // length = length.toFixed(4);
        this.lengthTotalizer += length;

        this.gVLogger.log("totalizerrrrrrr" + this.lengthTotalizer);
        }catch(error){
          this.gVLogger.log("error while reading length " + error);
        }


        item.attributesList = [];

        if(!item.attributeSearch){
          // item.attributeSearch = "5:2027>6:2764>7:2852>8:2875>9:2879";
          item.attributeSearch = "";
        }

        if(item.attributeSearch.indexOf('>') !== -1){
          let tempAttributesList = item.attributeSearch.split('>');
          for(let attribute of tempAttributesList){
            if(attribute!== "")
            item.attributesList.push({attributeId:attribute.split(':')[0],activeStatus: this.attributesPropertiesMap.get(attribute.split(':')[0]).attActiveStatus ,orderId:this.attributesPropertiesMap.get(attribute.split(':')[0]).attSequence||0,attribute:this.cartManager.getAttributeValue(attribute.split(':')[0]),attributeValue:this.cartManager.getAttributeValue(attribute)});
          }
        }
        item.attributesList.sort(function(a,b){return a.orderId-b.orderId})
      }

    this.totalQuantityOfSelectedProducts();
      this.shipOrderButton = true;
      this.downloadCSVButtonStatus = true;
      this.lengthTotalizerDecimalFix = this.lengthTotalizer.toFixed(2);

	    this.orderMessage = this.cart.orderMessage;
      this.currentDate = new Date();
      this.expectedShipmentDate = this.cart.expectedShipmentDate;
      this.TotalPriceBeforeTax = params.get("TotalPrice");
      //this.locationSelected = params.get("locationSelected");
      //this.taxAmount = this.TotalPriceBeforeTax  * this.taxPercent;
      this.TotalPrice = this.TotalPriceBeforeTax + this.taxAmount;
      this.getLocationById();
      this.updateOrderMessageInCART();
      // this.bolFormVariables();
  }


  totalQuantityOfSelectedProducts(){
    this.totalQtyOrdered = 0;
    this.totalQtyOfSelectedProducts= 0;
    for (let product of this.cart.items){
      this.totalQtyOrdered += product.quantity;
      for(let qty of product.productInventoryLocationsDTO){
        if(qty.status === 1){
          this.totalQtyOfSelectedProducts += qty.quantityReceived;
        }
      }
    }

    this.quantityRemainingInPickPack = this.totalQtyOrdered - this.totalQtyOfSelectedProducts;
  }



  ionViewDidLoad() {

    // setTimeout(() => {
    //   this.barcodeFocusOnProductScan.setFocus();
    //   // }
    // },800);
  }

  addFromBarCode(event){
    event.target.value = event.target.value.trim();

    console.log("AAAAAAAAAAAAAAAAA called ")

    if(this.productLocationDisplayStatus){
      this.productLocationDisplayStatus = false;


    let value = event.target.value;
    for(let product of this.cart.items){
      if(product.barCode === value && product.quantity > 0){
        let backup = JSON.stringify(product);
        this.api.get("/products/getProductsForPickShip/" + product.id).map(res => res.json()).subscribe(data => {
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          if(data.status === "200"){

            // let productLocationsModel = this.modalCtrl.create(ProductLocationsModelPage, { product: backup ,orderStatus: this.cart.orderStatus, data : data.data });
            // productLocationsModel.onDidDismiss(dataFromProductLocationsModel => {
            //   this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);
            //   if(dataFromProductLocationsModel !== null && dataFromProductLocationsModel !== undefined){
            //   }
            // })
            // productLocationsModel.present();

            let productLocationsModel = this.modalCtrl.create(ProductLocationsModelPage, { product: backup ,orderStatus: 1, data : "" }, {cssClass : "productLocationStyle"});
            productLocationsModel.onDidDismiss(dataFromProductLocationsModel => {
              this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);
              if(dataFromProductLocationsModel !== null && dataFromProductLocationsModel !== undefined){
                this.totalQuantityOfSelectedProducts();
              }
              this.pickLocationButtonStatus = false;
            })
            productLocationsModel.present();
          }
        });
        break;
      }
    }


    setTimeout(() =>{
      this.productLocationDisplayStatus = true;
    },1000)
  }
  }

  decodeData(encodeData){
    return	this.deoded=atob(encodeData);
    }


  getLocationById(){
        if(this.cart.customer.locationsDTOs[0].dropshipLocation === undefined || this.cart.customer.locationsDTOs[0].dropshipLocation === null)
          this.locationSelectedObject = this.cart.customer.locationsDTOs[0];
        else
          this.locationSelectedObject = JSON.parse(this.cart.customer.locationsDTOs[0].dropshipLocation);

        this.setCommaAddress1();
        this.setCommaAddress2();
        this.setCommaCity();
        this.setCommaState();
        this.shipto = [this.locationSelectedObject.addressLine1, this.spaceAddress1, this.locationSelectedObject.addressLine2, this.spaceAddress2,  this.locationSelectedObject.city, this.spaceCity, this.locationSelectedObject.state, this.spaceState, this.locationSelectedObject.country].join("");
        }

  setCommaCity(){
    if(this.locationSelectedObject.city === "" || this.locationSelectedObject.city === undefined || this.locationSelectedObject.city === null)
    {
      this.spaceCity = "";
    }
    else
    {
      this.spaceCity = ", ";
    }
  }

  setCommaState(){
    if(this.locationSelectedObject.state === "" || this.locationSelectedObject.state === undefined || this.locationSelectedObject.state === null)
    {
      this.spaceState = "";
    }
    else
    {
      this.spaceState = ", ";
    }
  }

  setCommaAddress1(){
    if(this.locationSelectedObject.addressLine1 === "" || this.locationSelectedObject.addressLine1 === undefined || this.locationSelectedObject.addressLine1 === null)
    {
      this.spaceAddress1 = "";
    }
    else
    {
      this.spaceAddress1 = ", ";
    }
  }

  setCommaAddress2(){
    if(this.locationSelectedObject.addressLine2 === "" || this.locationSelectedObject.addressLine2 === undefined || this.locationSelectedObject.addressLine2 === null)
    {
      this.spaceAddress2 = "";
    }
    else
    {
      this.spaceAddress2 = ", ";
    }
  }

  shipDateChanged(event){
    // this.gVLogger.log(this.expectedShipmentDate);
    this.cartManager.setShipDate(this.expectedShipmentDate);
  }

  updateOrderMessageInCART(){
    this.cartManager.setOrderMessage(this.orderMessage);
  }

  updateOrderMessage($event){
    // this.gVLogger.log("Blured called");
    this.updateOrderMessageInCART();
  }

  doPrint(){
    // alert("Printer is not available");
    this.gVLogger.log("Do print caldedd pick pack list");
    let options: PrintOptions = {
     name: 'Pick / Pack Ship'
    };

    Printer.isAvailable().then(
      function(){
        alert("Printer is available");
        Printer.print(document.getElementById("print-from-pp"), options).then(function(){},function(){});
      }
      ,
      function(){
        alert("Printer is not available");
      }
      );
  }

  imageNotFound(e,item){
   item.productImagesDTO[0].extension = "png";
   item.productImagesDTO[0].name = "dummy";
  }


  reOrder(){

  		// this.gVLogger.log(this.cart.customerDTO);

  		if(this.cartManager.getProductsCount()){

			let confirm = this.alertCtrl.create({
            title: 'Are you sure?',
            message: "Do you agree to delete all the Products for '"+ this.cartManager.getCustomerName() +"' from cart",
            buttons: [
              {
                text: 'Goto Cart', // cancel
                handler: () => {
                  this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
                }
              },
              {
                text: 'Discard Cart', // agree
                handler: () => {

                  this.addtoCart();

	            //     this.cartManager.setCustomer(this.cart.customer);
			        // this.cartManager.setOrderMessage(this.cart.orderMessage);
			        // this.cartManager.setOrderId(0);
			        // this.cartManager.setItems(this.cart.items);
			        // //this.nav.push(CartPage);
	            //     this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
                }
              }
            ]
          });
          confirm.present();

  		}else{
        this.addtoCart()
  		}


  }

  pickPackParams(){
    let cart:any = {};
    let paramProvider;

    this.api.get("/adpCust/getIntelliStockParams")
      .map(res => res.json())
      .subscribe((results)=>{
        if(results.status == "401"){ // check for session out
          this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

          this.nav.setRoot(LoginPage);
        }
        if(results.status === "200"){
          this.gVLogger.log("ccccccccccceeeeeeeelllllllllldddddddddddddd") ;
          paramProvider = this.decode(results.data);
          this.paramsProvider = JSON.parse(paramProvider);
          this.gVLogger.log("Params from the server : " + this.paramsProvider);
        }
      });

        cart.orderId = this.cart.orderId;

    let modal = this.modalCtrl.create(PickPackParamsPage,{"cart" : cart, "pickPackParams" : paramProvider});
        modal.onDidDismiss(data => {
              // this.gVLogger.log("data", data);
        });
        modal.present();
  }

  presentThankYouAlert(title,msg){
    let thankyouModal = this.modalCtrl.create(ThankYouModalPage, { title: title ,message: msg });
       thankyouModal.present();
  }

  presentPaySatusAlert(title,msg){
    this.gVLogger.log("LicenseStatusModelPage");
    let thankyouModal = this.modalCtrl.create(LicenseStatusModelPage, { title: title ,message: msg });
       thankyouModal.present();
  }

addtoCart(){
	this.cartManager.setCustomer(this.cart.customer);
  this.cartManager.setOrderMessage(this.cart.orderMessage);
  this.cartManager.setOrderId(0);
  this.cartManager.setItems(this.cart.items);
  //this.nav.push(CartPage);
  this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});
}

discountCheck(discountPrice){ // if discount price is > 0, return true
    if(Number(discountPrice) > 0){
      return true;
    }else{
      return false;
    }
  }




  decimalLengthFixed(num,max){
    return Number(num).toFixed(Math.max(2, (num.toString().split('.')[1] || []).length))
  }



  doPrintWeb(){

  this.printToCart("print-from");

    }


  printToCart(printSectionId: string){
          let popupWinindow;
          let innerContents = document.getElementById(printSectionId).innerHTML;
          popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
          popupWinindow.document.open();
          popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
          popupWinindow.document.close();
    }

    makeImageURL(dimensions,item){
  return this.cartManager.makeImageURL(dimensions,item);
}
billOfLading(){

  this.api.getADPPay("feature/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID() + "&featureAlias="+ this.constants.EDI_Integrations_License_alias+"&consumptionCount=0").map(res => res.json())
            .subscribe(data => {
              if(data.status === 570 || data.status === 571 || data.status === 403){

                this.presentPaySatusAlert("Failure", data.message);
                // this.presentThankYouAlert("Failure", data.message);
              }
              else if(data.status === 200 || data.status === 270){
                this.bolFormVariables();
                  setTimeout(()=> {
                this.printBOL("BOL-form");
                },1000)

              }
            });




    }

    printBOL(printSectionId: string){
      let popupWinindow;
      let innerContents = document.getElementById(printSectionId).innerHTML;
      popupWinindow = window.open('', '_blank', 'width=600,height=700,scrollbars=no,menubar=no,toolbar=no,location=no,status=no,titlebar=no');
      popupWinindow.document.open();
      popupWinindow.document.write('<html><head><link rel="stylesheet" type="text/css" href="style.css" /></head><body onload="window.print()">' + innerContents + '</html>');
      popupWinindow.document.close();
}


getSquareLogo(){
  // this.gVLogger.log("url" + IMAGES_BASE_URL + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000));
 return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

  imageNotFoundServer(event){
    event.target.src = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";
   }

  handleImgError(ev: any, item : any){
    let source = ev.srcElement;
    let imgSrc = "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/branding/default-logo.png";

    source.src = imgSrc;

 }

  getDefaultLogo(){
    return IMAGES_BASE_URL.imageBaseUrl + "/" + this.cartManager.getADPCustomerUUID() + "/branding/logoSquare.png?v="+Math.round((new Date()).getTime() / 1000);
  }

getFormLogo(){
    return "http://anydatapoint.net/f9c5c5ba-3900-4cdc-946d-93979d29f33c/document/cdw-bol-body.png";
  }

  locationAddress1(addressLine1){
    if(addressLine1 === "" || addressLine1 === null || addressLine1 === undefined){
      return false;
    }
    else
    {
      return true;
    }
  }

  decode(encodeData){
    return atob(encodeData);
    }


  processPickPackPrams(data){
    // if(data.status === "200" || data.status === "270"){
      if(data.data != ""){
      this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
    }
      'use strict';
    // Below code is from GA to map CSV field items
    // let temp1 =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});
    // this.gVLogger.log("tep1 data " + JSON.stringify(temp1) );

      let temp = [];
      let csvCustomFields = this.paramsProvider.customFields.documents.find(item=>item.name=="ASNCSV").documentParams;

     //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
      let csvCustomFieldsObjects = this.paramsProvider.customFields.params;
      let lineItems = this.cart.items;
      let strCart = JSON.stringify(this.cart);
      let objCart = JSON.parse(strCart);
      let objADPCust = this.salesPerson;
      let objOrder = [];
      let shiptoAddress = this.shipto;
      let TotalBeforeTax = this.TotalPriceBeforeTax;
      let index = 1;
      // let totalLength = this.lengthTotalizer.toFixed(4);

      for(let item of lineItems){
        let obj = {};
        for(let csvField of csvCustomFields){
          let label = "";
          let value = "";
          let type = "";
          let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

          type = cutomFieldObj.type;
          if( type === 'linked'){
            try{
              let itemLocal = item;
              let strExpr = cutomFieldObj.value;
            value = eval(strExpr.trim());
            }
            catch(error){
              this.gVLogger.log(error);
            }
          }
          else if(type === 'Empty'){
            try{
              let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
              if(value1 != "" || value1 != undefined){
                value = value1;
              }
              else{
                value = "";
              }
            }
            catch(error){
              // alert("value " + value)        ;
              // this.gVLogger.log(error);
            }
          }
      else{
        value = cutomFieldObj.value;
      }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = value;
     }
     temp.push(obj);
    index ++;
    }
    // return this.cartManager.ConvertToCSVDynamically(temp);
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "For 856 EDI.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    // }
    // else{
    //   this.gVLogger.log("else executed while read call give 404!");
    //   // this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
    //   'use strict';
    // // Below code is from GA to map CSV field items
    // // let temp1 =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});
    // // this.gVLogger.log("tep1 data " + JSON.stringify(temp1) );

    //   let temp = [];
    //   let csvCustomFields = this.paramsProvider.customFields.documents.find(item=>item.name=="ASNCSV").documentParams;

    //  //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
    //   let csvCustomFieldsObjects = this.paramsProvider.customFields.params;
    //   let lineItems = this.cart.items;
    //   let strCart = JSON.stringify(this.cart);
    //   let objCart = JSON.parse(strCart);
    //   let objADPCust = this.salesPerson;
    //   let objOrder = [];
    //   let shiptoAddress = this.shipto;
    //   let TotalBeforeTax = this.TotalPriceBeforeTax;
    //   let index = 1;
    //   // let totalLength = this.lengthTotalizer.toFixed(4);

    //   for(let item of lineItems){
    //     let obj = {};
    //     for(let csvField of csvCustomFields){
    //       let label = "";
    //       let value = "";
    //       let type = "";
    //       let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

    //       type = cutomFieldObj.type;
    //       if( type === 'linked'){
    //         try{
    //           let itemLocal = item;
    //           let strExpr = cutomFieldObj.value;
    //         value = eval(strExpr);
    //         }
    //         catch(error){
    //         }
    //       }
    //       else if(type === 'Empty'){
    //         try{
    //           let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
    //           if(value1 != "" || value1 != undefined){
    //             value = value1;
    //           }
    //           else{
    //             value = "";
    //           }
    //         }
    //         catch(error){
    //         }
    //       }
    //   else{
    //     value = cutomFieldObj.value;
    //   }
    //     obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = value;
    //  }
    //  temp.push(obj);
    // index ++;
    // }
    // // return this.cartManager.ConvertToCSVDynamically(temp);
    // var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    // var a = window.document.createElement("a");
    // a.href = window.URL.createObjectURL(blob);
    // a.download = "For 856 EDI.csv";
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
    // }
  // });
  // this.bolFormVariables();
  }

  processEmptyPickPackParams(){
    this.gVLogger.log("else executed while read call give 404!");
      // this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
      'use strict';
    // Below code is from GA to map CSV field items
    // let temp1 =  this.cart.items.map((o)=>{ return {id:o.id,Name:o.name,Quantity:o.quantity,barcode:o.barCode}});
    // this.gVLogger.log("tep1 data " + JSON.stringify(temp1) );

      let temp = [];
      let csvCustomFields = this.paramsProvider.customFields.documents.find(item=>item.name=="ASNCSV").documentParams;

     //create an array of key value type based on the 'parameters' object the corresponding values of the linked formula
      let csvCustomFieldsObjects = this.paramsProvider.customFields.params;
      let lineItems = this.cart.items;
      let strCart = JSON.stringify(this.cart);
      let objCart = JSON.parse(strCart);
      let objADPCust = this.salesPerson;
      let objOrder = [];
      let shiptoAddress = this.shipto;
      let TotalBeforeTax = this.TotalPriceBeforeTax;
      let index = 1;
      // let totalLength = this.lengthTotalizer.toFixed(4);

      for(let item of lineItems){
        let obj = {};
        for(let csvField of csvCustomFields){
          let label = "";
          let value = "";
          let type = "";
          let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

          type = cutomFieldObj.type;
          if( type === 'linked'){
            try{
              let itemLocal = item;
              let strExpr = cutomFieldObj.value;
            value = eval(strExpr);
            }
            catch(error){
            }
          }
          else if(type === 'Empty'){
            try{
              let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
              if(value1 != "" || value1 != undefined){
                value = value1;
              }
              else{
                value = "";
              }
            }
            catch(error){
            }
          }
      else{
        value = cutomFieldObj.value;
      }
        obj[cutomFieldObj.label + "~" + cutomFieldObj.paramId] = value;
     }
     temp.push(obj);
    index ++;
    }
    // return this.cartManager.ConvertToCSVDynamically(temp);
    var blob = new Blob([this.cartManager.ConvertToCSVDynamically(temp)]);
    var a = window.document.createElement("a");
    a.href = window.URL.createObjectURL(blob);
    a.download = "For 856 EDI.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    }
  // }

   getCSVFromCARTItems(){
     this.downloadCSVButtonStatus = false;

    //  this.api.get()
    // this.api.get("/lms/getLicenseStatus?customerUUID="+this.cartManager.getADPCustomerUUID()+"&bundleAlias=integrations-edi"+"&consumptionCount="+this.order.orderDetailDTOs.length).map(res => res.json())
    // .subscribe(data =>{


    // });

    this.api.post("/shipmentNotice/readPickPackParams?orderId="+this.cart.orderId+"&adpCustomerUUID="+this.cartManager.getADPCustomerUUID(), "").map(res => res.json()).subscribe(  data =>{

         this.gVLogger.log("adpCust"+ this.cartManager.getADPCustomerUUID() + this.cartManager.getAdpCustomerInfo());
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }


      // alert("failure " + data.data.json());
      try{
         let res = JSON.parse(data.data);
      }
      catch(error){

      }
      // let res = JSON.parse(data.data);
      // alert("failure " + res.status);
      // if(data.status === "570" || data.status === "571"){
        if(data.status === "570" || data.status === "571"){
        // alert("failure " + data.data.status);
        this.presentPaySatusAlert("Failure", data.data.map.message);
      }
      else if(data.status === "270"){
        let res = JSON.parse(data.message);
        this.msgManager.toastMsg(res.message);

        this.processPickPackPrams(data);
      }
      // else if(data.status === "200" ){  //UD
        else if(data.status === "200" && data.length != 0){
        this.processPickPackPrams(data);
      }
      else{
        this.processEmptyPickPackParams();
      }
      this.downloadCSVButtonStatus = true;
});

   }

  downloadCSV() {
    // alert(eval("this.paramsProvider.customFields.params"));
    // alert(eval("this.cart.customer.name"));
    this.gVLogger.log("downloadCSV called")
    // var blob = new Blob([this.getCSVFromCARTItems()]);
    // var a = window.document.createElement("a");
    // a.href = window.URL.createObjectURL(blob);
    // a.download = "For 856 EDI.csv";
    // document.body.appendChild(a);
    // a.click();
    // document.body.removeChild(a);
  }

  getOrderStatus(){
    // this.gVLogger.log("oooooorrrrrrdddddeeeeeerrrrrSSStatusdsds", this.cart.orderStatus)
    if(this.cart.orderStatus == 2 || this.cart.orderStatus == 5){
      return true;
    }
    else{
      return false;
    }
  }

  evenOddFun(i){
    i = i /2
    if(i /2 === 0){
      return true;
    }
    else{
      return false;
    }
  }

  resetOrder(){
    let confirm = this.alertCtrl.create({
        title: 'Reset Shipment & Order',
        message: 'Are you sure? You want to reset the shipment and the order. Also any active cart in progress will be discarded!',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
            //  this.gVLogger.log('Disagree clicked');
            }
          },
          {
            text: 'Agree',
            handler: () => {

    let productsList: any = [];
    for(let orderDetail of this.order.orderDetailDTOs){
      let product: any = orderDetail.productsDTO;
      productsList.push(product);
    }

    this.order.salesManId = this.cartManager.getSalesManId();
        if(this.cartManager.getProductsCount() > 0)
        {

          if(this.cartManager.getOrderId() == 0){
            this.gVLogger.log("Local Order");
            this.cartManager.clearCartProducts();
            this.cartManager.setOrderTitle("");
            this.cartManager.setOrderId(0);
            this.refreshTotalPrice();
            this.nav.setRoot(ItemsPage);
            this.cart.tempShipTo = undefined;
          }

        }

        this.api.post("order/resetOrder",this.order)
        .map(res=> res.json())
        .subscribe(data=>{
          if(data.status == "401"){ // check for session out
            this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

            this.nav.setRoot(LoginPage);
          }
          // alert("data status : " + data.status);
            if(data.status == 200){
              this.cartManager.setCustomer(this.order.customerDTO);
              this.cartManager.setOrderMessage(this.order.orderMessage);
              this.cartManager.setOrderId(this.order.id);
              // alert("Order id that is need to be set " + this.order.id);
              // alert("ordr id in reset" + this.cartManager.getOrderId());
              this.cartManager.setOrderTitle(this.cart.orderTitle);
              this.cartManager.setOrderStatus(2);
              this.cartManager.setShipDate(this.order.expectedShipmentDate);
              this.cartManager.setItems(productsList);
              this.nav.setRoot(ItemsPage).then(()=>{this.nav.push(CartPage)});


            }
          },err=>{
            // this.presentToast("some thing going wrong with background process");
          });

      // }
    }
  },
]
// }


});
confirm.present();

}



  refreshTotalPrice(){
    this.cart = CART;
    let temp:number = 0;
    for(let item of this.cart.items){
        if(this.discountCheck(item.discountPrice)){
          temp =  temp + (Number(item.discountPrice) * Number(item.quantity));
        }else{

        temp =  temp + (Number(item.price) * Number(item.quantity));
        }
    }
    this.TotalPriceBeforeTax =  Number(temp.toFixed(2));
    this.TAX = (this.TotalPriceBeforeTax * this.taxPercent);
   this.TotalPrice = this.TotalPriceBeforeTax + this.TAX;
    //alert(JSON.stringify(this.cart));
 }

 locationTypeCheck(locationsDTOs){

  for(let loc of locationsDTOs){
    // this.gVLogger.log("looooooooooop" + JSON.stringify(loc));
    if(loc.locationType === "BILLTO" || loc.locationType === "BILLTOSHIPTO"){
      // this.gVLogger.log("enetrrrrrr in if condition........." + loc);
      return this.selectFirstBillTo = loc;
    }
  }
}

bolFormVariables(){
                this.api.post("/shipmentNotice/readPickPackParams?orderId="+this.cart.orderId+"&adpCustomerUUID="+this.cartManager.getADPCustomerUUID(), "").map(res => res.json()).subscribe(  data =>{
                  if(data.status === "200" || data.status === "270"){
                    try{
                      this.pickPackParamsVariables = JSON.parse(this.decodeData(data.data));
                      this.SoldToCompany = this.pickPackParamsVariables.find(item=>item.paramId == 73).value;
                      this.SoldToAddress = this.pickPackParamsVariables.find(item=>item.paramId == 74).value;

                    }catch(err){

                      this.pickPackParamsVariables = "";
                      this.SoldToCompany = "";
                      this.SoldToAddress = "";
                    }
                let bolCustomFields = this.paramsProvider.customFields.documents.find(item=>item.name=="BOLForm").documentParams.find(Item=>Item.sectionLabel=="BOLHeader").fields;
                let csvCustomFieldsObjects = this.paramsProvider.customFields.params;
                // alert("bolCustomFields " + JSON.stringify( bolCustomFields));
                let lineItems = this.cart.items;
                    let strCart = JSON.stringify(this.cart);
                    let objCart = JSON.parse(strCart);
                    let objADPCust = this.salesPerson;
                    let objOrder = [];
                    let shiptoAddress = this.shipto;
                    let TotalBeforeTax = this.TotalPriceBeforeTax;
                    let index = 1;
                  this.BOLVariables = [];
                for(let csvField of bolCustomFields){
                  let obj ;
                  let label = "";
                  let value = "";
                  let type = "";
                  let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

                  type = cutomFieldObj.type;
                  if( type === 'linked'){
                    try{

                      let strExpr = cutomFieldObj.value;
                    value = eval(strExpr);
                    }
                    catch(error){
                    }
                  }
                  else if(type === 'Empty'){
                    try{
                      let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
                      if(value1 != "" || value1 != undefined){
                        // alert("value " + value1);
                        value = value1;
                      }
                      else{
                        value = "";
                      }
                    }
                    catch(error){
                    }
                  }
              else{
                value = cutomFieldObj.value;

              }
              // alert("value : " + value)
              obj = {
                "label" : cutomFieldObj.label,
                "value" : value
              }
              this.BOLVariables.push(obj);
              }
              }
              else{
                    try{
                      this.SoldToCompany = this.pickPackParamsVariables.find(item=>item.paramId == 73).value;
                    this.SoldToAddress = this.pickPackParamsVariables.find(item=>item.paramId == 74).value;
                    }catch(error){
                      this.gVLogger.log("error");
                    }

                  let bolCustomFields = this.paramsProvider.customFields.documents.find(item=>item.name=="BOLForm").documentParams.find(Item=>Item.sectionLabel=="BOLHeader").fields;
                  let csvCustomFieldsObjects = this.paramsProvider.customFields.params;
                  // alert("bolCustomFields " + JSON.stringify( bolCustomFields));
                  let lineItems = this.cart.items;
                    let strCart = JSON.stringify(this.cart);
                    let objCart = JSON.parse(strCart);
                    let objADPCust = this.salesPerson;
                    let objOrder = [];
                    let shiptoAddress = this.shipto;
                    let TotalBeforeTax = this.TotalPriceBeforeTax;
                    let index = 1;
                    // let totalLength = this.lengthTotalizer.toFixed(4);
                  this.BOLVariables = [];
                  for(let csvField of bolCustomFields){
                  let obj ;
                  let label = "";
                  let value = "";
                  let type = "";
                  let cutomFieldObj = csvCustomFieldsObjects.find(item=>item.paramId == csvField.paramId);

                  type = cutomFieldObj.type;
                  if( type === 'linked'){
                    // alert("if called of linked" + cutomFieldObj.value);
                    try{

                      let strExpr = cutomFieldObj.value;
                    value = eval(strExpr);
                    // alert("if called of  after eval" + value);
                    }
                    catch(error){
                      // alert("catch" + error);

                    }
                  }
                  else if(type === 'Empty'){
                    try{
                      let value1 = this.pickPackParamsVariables.find(item=>item.paramId == csvField.paramId).value;
                      if(value1 != "" || value1 != undefined){
                        // alert("value " + value1);
                        value = value1;
                      }
                      else{
                        value = "";
                      }
                    }
                    catch(error){

                    }
                  }
                  else{
                  value = cutomFieldObj.value;

                  }
                  // alert("value : " + value)
                  obj = {
                  "label" : cutomFieldObj.label,
                  "value" : value
                  }
                  this.BOLVariables.push(obj);
                  }
              }
              });

}

checkCompanyName(name){
  // alert(name);
  if(name != "" && name != undefined){
    return true;
  }
  else{
    return false;
  }
}

//
// when a user click on edit pick pack page then
// we get the products list against the order with the quantity order details.
// We also request server all the shipments or shipped quantites total across shipments
  // we subtract the total quantity shipped from total quantity ordered and display it against each product in the list (If the ordered quantity shipped then we do not display that product).
  // when user clicks edit pick locations then
// we get all the location from the server against that product.
  //Question? If user shifts out of the pickk ship page in the middle of picking products what will happen
  // Ans: "Are you sure to leave the shipment page? You will lose th picked items for the shipment"


  // The shipment no will be auto generated by the system starting from 101 for each order. we will still make sure the shipment no uniqueness at the clint level .
  // the picked quantity form the shipment and the picked quantity total for thr shipment will be two way binded. which means any change in picked quantity on either page with reflect the result on the other page

chooseFromLocations(product){
    this.pickLocationButtonStatus = true;
  this.gVLogger.log("LicenseStatusModelPage" +  product);
  let backup = JSON.stringify(product);
  this.gVLogger.log("LicenseStatusModelPageeeee" +  this.cart);
  // this.api.get("/products/getProductsForPickShip/" + product.id).map(res => res.json()).subscribe(data => {
  //   this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
  //     if(data.status === "200"){

        // let productLocationsModel = this.modalCtrl.create(ProductLocationsModelPage, { product: backup ,orderStatus: 1, data : "" }, {cssClass : "productLocationStyle"});
        let productLocationsModel = this.modalCtrl.create(ProductLocationsModelPage, { product: backup ,orderStatus: 1, data : "" }, {cssClass : "productLocationStyle"});
        productLocationsModel.onDidDismiss(dataFromProductLocationsModel => {
          this.gVLogger.log("Data from product location model in pickpack list : " + dataFromProductLocationsModel);
          if(dataFromProductLocationsModel !== null && dataFromProductLocationsModel !== undefined){
            this.totalQuantityOfSelectedProducts();
          }
          this.pickLocationButtonStatus = false;
        })
        productLocationsModel.present();
  //     }
  // });

}
    prodTotalQty(product){
      let prodTotalQty = 0;
      let quantityRemaining;
      // this.gVLogger.log("product in prodTotalQty prodTotalQty: " + JSON.stringify(product));
      for(let qty of product.productInventoryLocationsDTO) {
        prodTotalQty += qty.quantityReceived;
      }
      quantityRemaining = product.quantity - prodTotalQty;
      return quantityRemaining;
    }

  productInventoryLocationsDTO(product){
    let prodTotalQty = 0;
    let quantityRemaining;
    this.gVLogger.log("product in prodTotalQty in pick pack list : " + JSON.stringify(product));
    for(let qty of product.productInventoryLocationsDTO) {
      prodTotalQty += qty.quantityReceived;
    }
    quantityRemaining = product.quantity - prodTotalQty;
    this.gVLogger.log("product in quantityRemaining in pick pack list : " + quantityRemaining);
    if(quantityRemaining > 0){
      return true;
    }
    else {
      return false;
    }
  }


checkProductType(type){
  if(type === 0){
    return false;
  }
  else{
    return true;
  }
}

  reviewShipment(){
    this.gVLogger.log("shipment cart from data : " + JSON.stringify(this.shipmentCart));
    let orderPickPackList = this.order;
    let orderView = orderPickPackList;

    let cart:any = {};

    this.gVLogger.log(orderPickPackList);

    cart.customer = orderPickPackList.customerDTO;
    cart.orderMessage = orderPickPackList.orderMessage;
    cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
    cart.shippingServiceName = orderPickPackList.shippingServiceName;
    cart.shippingServiceId = orderPickPackList.shippingServiceValue;
    cart.orderId = orderPickPackList.id;
    // cart.items = productsList;
    cart.items = this.shipmentCartManager.getItems();
    cart.orderStatus = orderPickPackList.orderStatus;
    cart.orderTitle = orderPickPackList.orderTitle;


    // alert(this.shipmentsLength + " UD pickpack")

    this.nav.push(ShipmentReadyPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "shipmentsLength" : this.shipmentsLength, "pageStatus" : this.pageStatus});
  }


  popView(){
    alert("pop called")
    this.nav.pop();
  }

  productsIncart(){
    for(let prod of this.cart.items){
      this.gVLogger.log("products in cart calledddddddddd : " + JSON.stringify(prod) );
      if(prod.quantity > 0){
        this.allProdAvailCheck = true;
      }
    }
  }

  shipments(){
    this.gVLogger.log("shipments calledddddddd : ");
    var url = "/order/loadShipmentsByOrder";
    var body = "?searchString="+this.order.id;
    var shipmentAvail = false;
    this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
      this.gVLogger.log("data from /products/getProductsForPickShip : " + data);
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200") {

        for(let index of data.data) {
          this.gVLogger.log("index for loop in shipments + " + JSON.stringify(index.shipmentNoticeByNoticesId.shipmentNo))
          if (this.shipmentsData.length > 0) {
            shipmentAvail = false;
          for (let shipments of this.shipmentsData) {
            this.gVLogger.log("shipments for loop in shipments + " + JSON.stringify(shipments.shipmentNoticeByNoticesId.shipmentNo))

            if (shipments.shipmentNoticeByNoticesId.shipmentNo === index.shipmentNoticeByNoticesId.shipmentNo) {
              shipmentAvail = true;
            }
          }
        }
          this.gVLogger.log("shipment avail status : " + shipmentAvail);
          if(!shipmentAvail){
            this.shipmentsData.push(index);
          }
        }

        // this.shipmentsData = data.data;
        this.shipmentsLength =  this.shipmentsData.length;

        // alert(this.shipmentsLength + " UD")
        this.gVLogger.log("shipment length in pick pack list page : " + this.shipmentsLength);
        if(data.data.length > 0){

          this.shipmentsAvailabilityCheck = false;
        }
        else {
          this.shipmentsAvailabilityCheck = true;
        }
      }
      else {
        this.shipmentsData = [];
        this.shipmentsAvailabilityCheck = true;
      }
    });
  }

  shipmentDetails(shipment){

    if(this.productLocationDisplayStatus){
      this.productLocationDisplayStatus = false;

    this.gVLogger.log("tap called...");
    var url = "/order/loadShipment";
    var body = "?orderId="+this.order.id+"&shipmentId="+shipment.shipmentNoticeByNoticesId.id;
    this.api.post(url+body,null).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200") {
        let orderPickPackList = this.order;
        let orderView = orderPickPackList;


        let productsList: any = [];
        let productsListForShipment: any = [];
        for(let orderDetail of data.data.orderDetailShipmentDTOS){
          let product: any = orderDetail.productsDTO;
          productsList.push(product);
        }
        let cart:any = {};

        this.gVLogger.log(orderPickPackList);

        cart.customer = orderPickPackList.customerDTO;
        cart.orderMessage = orderPickPackList.orderMessage;
        cart.expectedShipmentDate = orderPickPackList.expectedShipmentDate;
        cart.shippingServiceName = orderPickPackList.shippingServiceName;
        cart.shippingServiceId = orderPickPackList.shippingServiceValue;
        cart.orderId = orderPickPackList.id;
        cart.items = productsList;
        // cart.items = this.shipmentCartManager.getItems();
        cart.orderStatus = orderPickPackList.orderStatus;
        cart.orderTitle = orderPickPackList.orderTitle;

        this.nav.push(ConfirmShipmentPage,{"cart":cart,"TotalPrice":orderPickPackList.totalAmount, "orderView" : orderView, "pageStatus" : "shipment", "plannedShipmentDate" : data.data.plannedShipmentDate, "shipmentNo" : shipment.shipmentNoticeByNoticesId.shipmentNo});
      }
      else {
        this.gVLogger.log("else calledd with shipmentDetails ");
      }
    });
    setTimeout(() => {
        this.productLocationDisplayStatus = true;
    },1000)
  }
}

  ngOnDestroy(){
  let prodPickedStatus = 0;
  let itemCountForOneOfItsKind = 0;
  let oneOfItsKindAvailCheck = false;
    for(let product of this.shipmentCartManager.getItems()){
      if(product.productType === 1){
        itemCountForOneOfItsKind += 1;
      }
        for(let qtyPicked of product.productInventoryLocationsDTO){
          if(qtyPicked.status === 1){
            prodPickedStatus = 1;
            break;
          }
        }
    }

    if(this.shipmentCartManager.getItems().length === itemCountForOneOfItsKind){
      oneOfItsKindAvailCheck = true;
    }
    if(this.shipmentCartManager.getItems().length > 0 && prodPickedStatus === 1 && oneOfItsKindAvailCheck === false){
      let confirm = this.alertCtrl.create({
        title: 'Unsaved cart found.',
        message: "What would you like to do?",
        buttons: [
          {
            text: 'Go to old cart',
            handler: () => {
              let orderView = this.order;

              this.gVLogger.log("orrrdddeeeerrrr before before adding in shipment cart manager : " + JSON.stringify(this.order));

              let productsList: any = [];
              for(let orderDetail of this.order.orderDetailDTOs){
                let product: any = orderDetail.productsDTO;
                productsList.push(product);
                this.shipmentCartManager.addProductToCart(product);
              }

              for(let ship of this.shipmentCartManager.getItems()){   // UD code in server down
                if(ship.productType === 1){
                  ship.productInventoryLocationsDTO[0].quantityReceived = ship.quantity;
                  ship.productInventoryLocationsDTO[0].status = 1;
                }
              }



              let cart:any = {};

              this.gVLogger.log(this.order);

              cart.customer = this.order.customerDTO;
              cart.orderMessage = this.order.orderMessage;
              cart.expectedShipmentDate = this.order.expectedShipmentDate;
              cart.shippingServiceName = this.order.shippingServiceName;
              cart.shippingServiceId = this.order.shippingServiceValue;
              cart.orderId = this.order.id;
              // cart.items = productsList;
              cart.items = this.shipmentCartManager.getItems();
              cart.orderStatus = this.order.orderStatus;
              cart.orderTitle = this.order.orderTitle;

              // this.gVLogger.log(JSON.stringify(cart));
              this.storage.set("orderInStorage", this.order);
              if(Constants.isWebstore){
                this.nav.push(PickpacklistPage,{"cart":cart,"TotalPrice":this.order.totalAmount, "orderView" : orderView})
              }else{
                this.nav.push(PickpacklistPage,{"cart":cart,"TotalPrice":this.order.totalAmount, "orderView" : orderView});

              }
            }
          },
          {
            text: 'Replace with new cart',
            handler: () => {
              this.shipmentCartManager.clearCart();

            }
          }
        ]
      });
      confirm.present();
    }
    else {
      this.shipmentCartManager.clearCart();
    }

      }


  onFocusBarcode(event){
    event.target.value = "";
  }
  onBlurBarcode(event){
    event.target.value = "";
  }

  viewItem(item) {

    this.api.get("product/" + item.id + "/?isWebStore=" + 1).map(res => res.json()).subscribe(data => {
      if(data.status == "401"){ // check for session out
        this.msgManager.toastMsg(this.msgManager.getSessionOutMsg());

        this.nav.setRoot(LoginPage);
      }
      if(data.status === "200"){
        item.description = data.data.description;
      }
    })
    this.nav.push(ItemPage, {item: item})
  }

}



// WEBPACK FOOTER //
// ./src/pages/pickpacklist/pickpacklist.ts